"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AngleBracketsWithPercentSigns_1 = __importDefault(require("./AngleBracketsWithPercentSigns"));
/**
 * Options for replacing tags using angle brackets with percent signs (`<%` `%>`).
 * Matches tags of the form `<%variable%>` in the text.
 * @example
 * // Example usage:
 * const text = 'Hello <%variable%>';
 * const result = replaceTags(text, { variable: 'world' }, PercentBrackets);
 * console.log(result); // Output: 'Hello world'
 */
var PercentBrackets = __assign(__assign({}, AngleBracketsWithPercentSigns_1.default), { name: "Percent Brackets" });
exports.default = PercentBrackets;
